export default __webpack_public_path__ + "static/char-s-43-zh-Hant-8429f37bef1c0501bf9d79497f3a99f4.png";